export const styles = {
  container: {
    flexDirection: 'column',
  },
  membershipContainer: {
    flexDirection: ['column', null, 'row'],
    justifyContent: 'space-between',
  },
  membershipText: {
    flexBasis: ['100%', null, '34%'],
  },
  membershipBox: {
    flexBasis: ['100%', null, '60%'],
  },
};
